<template>
  <el-dialog :title="title" v-model="show" size="full">
    <div v-loading="loading" :element-loading-text="isEditData === 0 ? '修改保存中。。。' : '新增保存中。。。'">
      <el-row>
        <el-col :span=8>
          <el-form ref="kInfo1" :model="kInfo1" label-width="120px">
          	<el-form-item label="guid">
              <el-input v-model="kInfo1.guid" placeholder="guid"></el-input>
            </el-form-item>
            <el-form-item label="标题">
              <el-input v-model="kInfo1.title" placeholder="标题,60字以内"></el-input>
            </el-form-item>
            <el-form-item label="类型">
              <el-input v-model="kInfo1.type" placeholder="类型,60字以内"></el-input>
            </el-form-item>
            <el-form-item label="原作者GUID">
              <el-input v-model="kInfo1.author2Guid" placeholder="原作者GUID,如果没有，需填入0"></el-input>
            </el-form-item>
            <el-form-item label="keyword2" class="h20">
              <el-input v-model="kInfo1.keyword2" placeholder="用于生成静态页面的keywords，尽量多填"></el-input>
            </el-form-item>
            <el-form-item label="description" class="h20">
              <el-input v-model="kInfo1.description" placeholder="用于生成静态页面的description，尽量多填"></el-input>
            </el-form-item>
            <el-form-item >
              <el-button @click="saveKnowledge">保存知识点</el-button>
              <!-- <el-button @click="weixin">微信证书test</el-button>-->
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span=1>
          &nbsp;
        </el-col>
        <el-col :span=15>
          <el-row>
            <span>知识点内容</span>
          </el-row>
          <el-row>
            <div id="standalone-container_zsd" style="margin: 50px auto;max-width: 100%;">
              <div id="toolbar"></div>
              <div id="editor" style="height:calc(100vh - 200px);"></div>
            </div>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
  import { addNewKnowledge, getKnowledgeByGuid, updateKnowledgeByGuid, weixintest } from '@/api/api_knowledge.js'
  import { setEditor } from '@/utils/quill.table'

  export default {
    data () {
      return {
        show: false,
        loading: false,
        tempstr: '',
        guid: '',
        isEditData: false,
        kInfo1: {
          guid: '',
          title: '',
          type: '',
          content: '',
          author2Guid: '', // 知识点原作者
          description: '',
          keyword2: ''
        },
        quill: null,
        toolbarOptions: [
          // ['contain'],
          [{'table': ['newtable_1_1', 'newtable_1_2', 'newtable_1_3', 'newtable_1_4', 'newtable_1_5', 'newtable_2_1', 'newtable_2_2', 'newtable_2_3', 'newtable_2_4', 'newtable_2_5', 'newtable_3_1', 'newtable_3_2', 'newtable_3_3', 'newtable_3_4', 'newtable_3_5']}],
          [{'table': 'append-row'}],
          [{'table': 'append-col'}],
          [{'table': 'remove-row'}], // cursor needs to be in the table
          [{'table': 'remove-col'}], // cursor needs to be in the table
          [{'table': 'remove-table'}], // cursor needs to be in the table
          [{'table': 'cell-background'}],
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote', 'code-block'],
          [{'header': 1}, {'header': 2}],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'script': 'sub'}, {'script': 'super'}],
          [{'indent': '-1'}, {'indent': '+1'}],
          [{'direction': 'rtl'}],
          [{'size': ['small', false, 'large', 'huge']}],
          [{'header': [1, 2, 3, 4, 5, 6, false]}],
          [{'color': []}, {'background': []}],
          [{'align': []}],
          ['link', 'image'],
          ['formula', 'clean', 'video']
        ]
      }
    },
    computed: {
      title () {
        return `编辑知识点-${this.isEditData === true ? '修改' : '新增'}`
      }
    },
    watch: {
      show: function (val) {
        if (val) {
          this.markDown()
        }
      }
    },
    mounted () {

    },
    methods: {
      markDown () {
        setTimeout(() => {
          if (!this.quill) {
            this.quill = new window.Quill('#editor', {
              modules: {
                formula: true,
                syntax: true,
                toolbar: {
                  container: this.toolbarOptions,
                  handlers: {
                    image: this.imageHandler
                  }
                }
              },
              placeholder: 'Compose an epic...',
              theme: 'snow'
            })
            setEditor(this.quill)
            if (this.isEditData === true) {
              this.loadData()
            }
          }
        }, 1000)
      },
      imageHandler () {
        console.log('65')
        var range = this.quill.getSelection()
        var value = prompt('What is the image URL')
        this.quill.insertEmbed(range.index, 'image', value, window.Quill.sources.USER)
      },
      closeDlg () {
        this.show = false
      },
      showMsg (msg, type = 'warning') {
        this.$notify({
          title: '知识点',
          message: msg,
          type: type
        })
      },
      weixin () {
        let d = {}
        d.mch_id = 'wx9e060fd2c6b37704'
        d.nonce_str = 'thiskInfo1content'
        d.sign = 'EdfO0uMgB41qSxy1WckKcVuOGdfhZc6JnMGMU3pbIF2'
        weixintest(d).then((res) => {
          if (res) {
            console.log('wei xin res1=' + res)
          } else {
            console.log('wei xin res2=' + res)
          }
        }).catch(err => {
          console.log('wei xin err=' + err)
        })
      },
      saveKnowledge () {
        // 保存知识点
        console.log('保存知识点 this.kInfo1=' + JSON.stringify(this.kInfo1))
        this.kInfo1.content = JSON.stringify(this.quill.getContents())
        if (this.isEditData === true) {
          // 保存修改
          updateKnowledgeByGuid(this.kInfo1).then((res) => {
            if (res.data) {
              if (res.data.isOk === true) {
                this.showMsg('修改知识点成功。', 'info')
              } else {
                this.showMsg('修改知识点失败。', 'info')
              }
            } else {
              this.showMsg('修改知识点不成功。', 'info')
            }
          }).catch(err => {
            this.showMsg(`修改知识点失败。${err}`)
          })
        } else {
          // 保存新增
          addNewKnowledge(this.kInfo1).then((res) => {
            if (res.data) {
              if (res.data.isOk === true) {
                this.showMsg('添加知识点成功。', 'info')
              } else {
                this.showMsg('添加知识点失败。', 'info')
              }
            } else {
              this.showMsg('添加知识点不成功。', 'info')
            }
          }).catch(err => {
            this.showMsg(`添加知识点失败。${err}`)
          })
        }
      },
      loadData () {
        console.log('knowledge--load data,guid=' + this.guid)
        if (this.isEditData === true) {
          this.loading = true
          getKnowledgeByGuid(this.guid).then((res) => {
            let data = res.data
            if (data.isOk) {
              this.kInfo1 = data.data[0]
              let tk = JSON.parse(this.kInfo1.content)
              console.log(tk.ops)
              if (this.quill) {
                this.quill.setContents(tk.ops)
                this.quill.enable(true)
              } else {
                console.log('quill初始化失败。')
              }
            } else {
              this.showMsg('获取知识点失败，请关闭修改对话框后重新再试！')
            }
            this.loading = false
          }).catch((err) => {
            this.showMsg(err)
            this.loading = false
          })
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// main.vue?7c2ebe24